import { Report, User, Video } from '../types';
import { canReceiveVideoModerated, getAppLabel, getMinVersionLabel } from './user';

const getShortUrl = (video: Partial<Video>) => `${window.location.origin}/short/${video.codeshare}`;

// The file comes from CloudFront: a blob is needed so the browser saves it instead of opening it.
const downloadVideo = async (video: Partial<Video>) => {
  const url = `${process.env.REACT_APP_AWS_CLOUDFRONT_URL}${video.short || video.path}`;
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${video.codeshare || video.id}.mp4`;
    link.click();
    window.URL.revokeObjectURL(link.href);
  } catch (err) {
    window.open(url, '_blank');
  }
};

// Thumbnail of a video saved as <username>-<videoId>.<ext>, opened in a tab when CloudFront refuses the fetch (CORS).
const downloadThumbnail = async (thumbnail: string, name: string) => {
  const url = `${process.env.REACT_APP_AWS_CLOUDFRONT_URL}${thumbnail}`;
  const file = thumbnail.split('?')[0].split('/').pop() || '';
  let extension = 'jpg';
  if (file.includes('.')) {
    extension = file.split('.').pop() as string;
  }
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(String(response.status));
    }
    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${name}.${extension}`;
    link.click();
    window.URL.revokeObjectURL(link.href);
  } catch (err) {
    window.open(url, '_blank');
  }
};

// Message shown to the admin after a removal: did the creator get the reason?
const getRemovalMessage = (report: Partial<Report>, t: any) => {
  const user = report.user || {} as Partial<User>;
  const username = user.username;
  if (report.isNotified) {
    return { severity: 'success' as const, text: t('admin.videos.removedNotified', { username }) };
  }
  let reason = t('admin.videos.noAppReason');
  const app = getAppLabel(user);
  if (app && !canReceiveVideoModerated(user)) {
    reason = t('admin.videos.oldApp', { app, min: getMinVersionLabel(user) });
  } else if (app) {
    reason = '';
  }
  return {
    severity: 'warning' as const,
    text: t('admin.videos.removedNotNotified', { username, reason }).trim(),
  };
};

export { downloadThumbnail, downloadVideo, getRemovalMessage, getShortUrl };
